import React from 'react';
import { motion } from 'framer-motion';
export function TomosSection() {
  return <>
      <section className="py-10 md:py-14 px-4 bg-gray-50 text-center" data-id="element-265">
        <div className="max-w-4xl mx-auto" data-id="element-266">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-267">
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-2" data-id="element-268">
              📘 ¿Qué incluye exactamente el MegaPack?
            </h2>
            <p className="text-xl font-bold text-red-600 mb-2" data-id="element-269">
              El sistema completo para adelgazar con Airfryer
            </p>
            <p className="text-base text-gray-600 mb-6" data-id="element-270">
              Este megapack incluye 6 tomos diseñados paso a paso.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-271">
              {/* TOMO 1 */}
              <div className="bg-white p-5 rounded-2xl shadow-lg border border-gray-100" data-id="element-272">
                <div className="bg-red-100 text-red-800 font-black text-xs px-3 py-1 rounded-full inline-block mb-2" data-id="element-273">
                  TOMO 1
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-274">
                  Fundamentos para adelgazar con Airfryer
                </h3>
                <p className="text-gray-600 font-medium mb-2 text-sm" data-id="element-275">
                  Aprenderás:
                </p>
                <ul className="space-y-1 text-gray-700 text-sm" data-id="element-276">
                  <li className="flex items-start" data-id="element-277">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-278">✔</span> cómo
                    funciona la airfryer
                  </li>
                  <li className="flex items-start" data-id="element-279">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-280">✔</span> por
                    qué ayuda a reducir calorías
                  </li>
                  <li className="flex items-start" data-id="element-281">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-282">✔</span> cómo
                    estructurar comidas saludables
                  </li>
                  <li className="flex items-start" data-id="element-283">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-284">✔</span>{' '}
                    errores comunes al intentar adelgazar
                  </li>
                </ul>
              </div>

              {/* TOMO 2 */}
              <div className="bg-white p-5 rounded-2xl shadow-lg border border-gray-100" data-id="element-285">
                <div className="bg-red-100 text-red-800 font-black text-xs px-3 py-1 rounded-full inline-block mb-2" data-id="element-286">
                  TOMO 2
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-287">
                  Recetas saludables para el día a día
                </h3>
                <p className="text-gray-600 font-medium mb-1 text-sm" data-id="element-288">
                  Incluye recetas fáciles como:
                </p>
                <p className="text-gray-700 italic mb-2 text-sm" data-id="element-289">
                  pollo crujiente saludable • salmón con verduras • chips de
                  boniato • verduras crujientes
                </p>
                <ul className="space-y-1 text-gray-700 font-bold text-sm" data-id="element-290">
                  <li className="flex items-center" data-id="element-291">
                    <span className="text-green-500 mr-2" data-id="element-292">✔</span> rápidas
                  </li>
                  <li className="flex items-center" data-id="element-293">
                    <span className="text-green-500 mr-2" data-id="element-294">✔</span> económicas
                  </li>
                  <li className="flex items-center" data-id="element-295">
                    <span className="text-green-500 mr-2" data-id="element-296">✔</span> bajas en
                    calorías
                  </li>
                </ul>
              </div>

              {/* TOMO 3 */}
              <div className="bg-white p-5 rounded-2xl shadow-lg border border-gray-100" data-id="element-297">
                <div className="bg-red-100 text-red-800 font-black text-xs px-3 py-1 rounded-full inline-block mb-2" data-id="element-298">
                  TOMO 3
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-299">
                  Planificación de comidas para adelgazar
                </h3>
                <p className="text-gray-600 font-medium mb-2 text-sm" data-id="element-300">
                  Aprenderás:
                </p>
                <ul className="space-y-1 text-gray-700 text-sm" data-id="element-301">
                  <li className="flex items-start" data-id="element-302">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-303">✔</span>{' '}
                    organizar tu semana
                  </li>
                  <li className="flex items-start" data-id="element-304">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-305">✔</span>{' '}
                    evitar improvisar comidas poco saludables
                  </li>
                  <li className="flex items-start" data-id="element-306">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-307">✔</span> crear
                    menús equilibrados
                  </li>
                </ul>
              </div>

              {/* TOMO 4 */}
              <div className="bg-white p-5 rounded-2xl shadow-lg border border-gray-100" data-id="element-308">
                <div className="bg-red-100 text-red-800 font-black text-xs px-3 py-1 rounded-full inline-block mb-2" data-id="element-309">
                  TOMO 4
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-310">
                  Batch cooking con Airfryer
                </h3>
                <p className="text-gray-600 font-medium mb-2 text-sm" data-id="element-311">
                  Descubre cómo preparar varias comidas en una sola sesión.
                </p>
                <ul className="space-y-1 text-gray-700 text-sm" data-id="element-312">
                  <li className="flex items-start" data-id="element-313">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-314">✔</span>{' '}
                    ahorrar tiempo
                  </li>
                  <li className="flex items-start" data-id="element-315">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-316">✔</span> tener
                    comidas saludables listas
                  </li>
                  <li className="flex items-start" data-id="element-317">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-318">✔</span>{' '}
                    evitar comida rápida
                  </li>
                </ul>
              </div>

              {/* TOMO 5 */}
              <div className="bg-white p-5 rounded-2xl shadow-lg border border-gray-100" data-id="element-319">
                <div className="bg-red-100 text-red-800 font-black text-xs px-3 py-1 rounded-full inline-block mb-2" data-id="element-320">
                  TOMO 5
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-321">
                  Postres saludables en Airfryer
                </h3>
                <p className="text-gray-600 font-medium mb-1 text-sm" data-id="element-322">
                  Porque adelgazar no significa renunciar al dulce.
                </p>
                <p className="text-gray-600 font-medium mb-1 text-sm" data-id="element-323">
                  Recetas como:
                </p>
                <p className="text-gray-700 italic text-sm" data-id="element-324">
                  brownies saludables • tartas ligeras • snacks dulces sin culpa
                </p>
              </div>

              {/* TOMO 6 */}
              <div className="bg-white p-5 rounded-2xl shadow-lg border border-gray-100" data-id="element-325">
                <div className="bg-red-100 text-red-800 font-black text-xs px-3 py-1 rounded-full inline-block mb-2" data-id="element-326">
                  TOMO 6
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-327">
                  Mantener resultados sin efecto rebote
                </h3>
                <p className="text-gray-600 font-medium mb-2 text-sm" data-id="element-328">
                  Aprenderás:
                </p>
                <ul className="space-y-1 text-gray-700 text-sm" data-id="element-329">
                  <li className="flex items-start" data-id="element-330">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-331">✔</span>{' '}
                    mantener hábitos
                  </li>
                  <li className="flex items-start" data-id="element-332">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-333">✔</span>{' '}
                    evitar recuperar peso
                  </li>
                  <li className="flex items-start" data-id="element-334">
                    <span className="text-green-500 mr-2 mt-0.5" data-id="element-335">✔</span>{' '}
                    convertir la alimentación saludable en un estilo de vida
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* BEFORE / AFTER SECTION */}
      <section className="py-10 md:py-14 px-4 bg-black text-white text-center" data-id="element-336">
        <div className="max-w-4xl mx-auto" data-id="element-337">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-338">
            <h2 className="text-4xl md:text-5xl font-extrabold mb-6 text-yellow-400" data-id="element-339">
              🔄 Antes vs Después
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-340">
              <div className="bg-red-950/40 border-2 border-red-900 rounded-2xl p-6 text-left" data-id="element-341">
                <h3 className="text-2xl font-bold text-red-500 mb-4 flex items-center" data-id="element-342">
                  <span className="mr-3" data-id="element-343">❌</span> Antes
                </h3>
                <ul className="space-y-3 text-lg text-gray-300" data-id="element-344">
                  <li className="flex items-center" data-id="element-345">
                    <span className="text-red-500 mr-3" data-id="element-346">✗</span> dietas
                    difíciles
                  </li>
                  <li className="flex items-center" data-id="element-347">
                    <span className="text-red-500 mr-3" data-id="element-348">✗</span> comida aburrida
                  </li>
                  <li className="flex items-center" data-id="element-349">
                    <span className="text-red-500 mr-3" data-id="element-350">✗</span> poco tiempo
                    para cocinar
                  </li>
                  <li className="flex items-center" data-id="element-351">
                    <span className="text-red-500 mr-3" data-id="element-352">✗</span> frustración
                    constante
                  </li>
                </ul>
              </div>

              <div className="bg-green-950/40 border-2 border-green-600 rounded-2xl p-6 text-left shadow-[0_0_30px_rgba(34,197,94,0.2)]" data-id="element-353">
                <h3 className="text-2xl font-bold text-green-400 mb-4 flex items-center" data-id="element-354">
                  <span className="mr-3" data-id="element-355">✅</span> Después
                </h3>
                <ul className="space-y-3 text-lg text-white font-medium" data-id="element-356">
                  <li className="flex items-center" data-id="element-357">
                    <span className="text-green-400 mr-3" data-id="element-358">✓</span> comidas
                    deliciosas
                  </li>
                  <li className="flex items-center" data-id="element-359">
                    <span className="text-green-400 mr-3" data-id="element-360">✓</span> menos
                    calorías
                  </li>
                  <li className="flex items-center" data-id="element-361">
                    <span className="text-green-400 mr-3" data-id="element-362">✓</span> organización
                    semanal
                  </li>
                  <li className="flex items-center" data-id="element-363">
                    <span className="text-green-400 mr-3" data-id="element-364">✓</span> hábitos
                    sostenibles
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}